import { IItem, IAlternative } from "../../../../domain/document/items";
import { IObjectsAlternatable } from "../";
import { Section } from "../../../../domain/document";

export abstract class AbstractAlternator implements IObjectsAlternatable {
  public alternate(items: IItem[], sections: Section[]): IItem[] {
    const results = items.concat();
    for (const i of this.createAlternativeItems(results, sections)) {
      for (const c of i.alternatedContents) {
        results[c.privateId] = null;
      }
      results[i.privateId] = i;
    }
    return results;
  }

  protected abstract createAlternativeItems(items: IItem[], sections: Section[]): (IAlternative)[];
}
